export const langTxt: any = {
    us: {
        ask: 'Online 24 hours',
        collapse: 'Collapse',
    },
    cn: {
        ask: '24小时在线',
        collapse: 'Collapse',
    },
    jp: {
        ask: '24時間オンライン',
        collapse: 'Collapse',
    },
    de: {
        ask: 'Online 24 Stunden',
        collapse: 'Collapse',
    },
    fr: {
        ask: 'En ligne 24 heures',
        collapse: 'Collapse',
    },
    kr: {
        ask: '온라인 24 시간',
        collapse: 'Collapse',
    },
    es: {
        ask: 'En línea 24 horas',
        collapse: 'Collapse',
    },
    it: {
        ask: 'Online 24 ore su 24',
        collapse: 'Collapse',
    },
    nl: {
        ask: 'Online 24 uur',
        collapse: 'Collapse',
    },
    br: {
        ask: 'Online 24 horas',
        collapse: 'Collapse',
    },
};
